import React from 'react';
import Content from "./Content";

const MessageBoard = () => {
    return (
        <>
            <Content />
        </>
    )
}
 export default MessageBoard;